<template>
  <div>
    <!-- 面包屑 -->
    <breadcrumbs></breadcrumbs>
    <!-- 返回按钮 -->
    <div
      class="topReturnLink w60 fw-600 color0063ea f16 pdb-10 cursor"
      @click="$router.push('/waterCard/cardList')"
    >
      <i class="el-icon-arrow-left fw-600"></i>
      返回
    </div>
    <div class="flex aic mgt-20">
      <div
        :class="selectActive == v.id ? 'selectActive' : 'select'"
        v-for="(v, i) in selectArr"
        :key="i"
        @click="selectActive = v.id"
      >
        {{ v.name }}
      </div>
    </div>
    <div class="colorRed mgt-10">
      *可将普通实物卡转换为时效实物卡，转换成功后实物卡仅支持充值时效套餐，且仅支持充值一次。
    </div>
    <!-- 导表分配 -->
    <div v-show="selectActive == 1">
      <div class="fw-600 mgt-20">批量导入水卡</div>
      <div
        class="color0063ea mgt-30"
        style="cursor: pointer;"
        @click="download"
      >
        下载Excle示例
      </div>
      <div class="fw-600 mgt-30 mgb-30">导入Excel</div>
      <el-upload
        ref="upload2"
        :action="'#'"
        :limit="1"
        :multiple="false"
        :auto-upload="false"
        accept=".xls,.xlsx"
        :file-list="fileList"
        :http-request="uploadFile"
        :on-change="fileChange"
        :on-exceed="handleExceed"
        :on-remove="handleRemove"
      >
        <el-button size="small" type="primary">文件浏览</el-button>
      </el-upload>
      <el-button @click="daoruSure" class="mgt-20">确定</el-button>
    </div>
    <!-- 手动分配 -->
    <div v-show="selectActive == 2" class="mgt-20">
      <el-form ref="form" :rules="rules" :model="form" label-width="80px">
        <el-form-item label="卡号" prop="cardNum">
          <el-input v-model="form.cardNum" placeholder="请输入卡号"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="shoudongQueding('form')"
            >确定</el-button
          >
        </el-form-item>
      </el-form>
    </div>
    <el-table
      class="mgt-20"
      :data="tableData"
      border
      stripe
      style="width: 100%"
    >
      <el-table-column
        type="index"
        :index="indexMethod"
        label="序号"
        width="50"
        fixed="left"
      >
      </el-table-column>
      <el-table-column prop="cardId" label="卡号"> </el-table-column>
      <el-table-column prop="type" label="操作类型"> </el-table-column>
      <el-table-column prop="msg" label="备注"> </el-table-column>
      <el-table-column prop="desc" label="操作结果"> </el-table-column>
    </el-table>
  </div>
</template>

<script>
import breadcrumbs from "@/components/breadcrumbs.vue";
import { handleConfirm, handleAlert } from "../../components/UtilsIf";
export default {
  components: {
    breadcrumbs,
  },
  data() {
    return {
      selectArr: [
        { name: "批量导表", id: 1 },
        { name: "手动新增", id: 2 },
      ],
      selectActive: 1,
      fileList: [], //导入的文件列表
      fileName: "",
      tableData: [],
      tableData2: [],
      form: {
        cardNum: "",
      },
      rules: {
        cardNum: [{ required: true, message: "请输入卡号", trigger: "blur" }],
      },
    };
  },
  methods: {
    shoudongQueding(d) {
      this.$refs[d].validate((valid) => {
        if (valid) {
          handleConfirm(
            "水卡一旦转换为时效卡后将无法恢复，确定将水卡类型变更为时效实物卡吗?",
            "info"
          )
            .then(() => {
              this.$api.waterCard
                .timeCard({ cardNum: this.form.cardNum })
                .then((res) => {
                  if (res.code === 200) {
                    this.tableData = [];
                    this.tableData.push(res.data);
                  }
                });
            })
            .catch(() => {
              return;
            });
        } else {
          return false;
        }
      });
    },
    // 导表模板下载
    download() {
      this.$api.waterCard.template().then((res) => {
        const link = document.createElement("a");
        link.style.display = "none";
        link.href = URL.createObjectURL(res);
        link.setAttribute("download", "实物卡列表.xls");
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      });
    },
    daoruSure() {
      if (this.fileList.length == 0) {
        handleAlert("请上传文件", "error");
        return;
      }
      handleConfirm(
        "水卡一旦转换为时效卡后将无法恢复，确定将水卡类型变更为时效实物卡吗?",
        "info"
      )
        .then(() => {
          this.$refs.upload2.submit();
        })
        .catch(() => {
          return;
        });
    },
    /* 自定义上传 */
    uploadFile(params) {
      // 通过 FormData 对象上传文件
      let formData = new FormData();
      formData.append("file", params.file);

      /* 在这里发请求就行了 */
      /* ------------------------------------ */
      this.$api.waterCard
        .timeCardupload({
          file: formData,
        })
        .then((res) => {
          if (res.code === 200) {
            this.tableData = res.data;
          }
        });
      /* ------------------------------------ */

      // 成功失败都删除文件;
      this.fileList.splice(-1, 1);
    },
    /* 文件上传后的钩子  在此做校验 */
    fileChange(file, fileList) {
      this.file = file;
      // console.log(fileList);
      this.fileList = fileList;
      console.log(this.fileList, "已上传的");
      console.log(file, fileList, "第一个");
      let extension = file.name.substring(file.name.lastIndexOf(".") + 1);
      if (extension !== "xlsx" && extension !== "xls") {
        this.$message.warning("只能上传后缀是.xlsx和xls的文件");
        fileList.splice(-1, 1); //移除错误文件
        return;
      }
      // 文件大小校验
      const size = file.size / 1024 / 1024;
      if (size > 5) {
        this.$message.warning("文件大小不得超过5M");
        fileList.splice(-1, 1); //移除错误文件
        return;
      }
      this.fileName = file.name;
    },
    /* 超出个数 */
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 1 个文件，本次选择了 ${
          files.length
        } 个文件，共选择了 ${files.length + fileList.length} 个文件`
      );
    },
    // 导入的文件删除
    handleRemove(file, fileList) {
      console.log(file, fileList, "删除");
      this.fileList = fileList;
    },
    //表格序号，根据索引+1
    indexMethod(index) {
      return index + 1;
    },
    indexMethod2(index) {
      return index + 1;
    },
  },
};
</script>

<style lang="scss" scoped>
.select {
  width: 300px;
  height: 30px;
  text-align: center;
  border: 1px solid var(--input-border);
  background: var(--card-bg);

  line-height: 30px;
  margin-right: 50px;
  cursor: pointer;
}
.selectActive {
  width: 300px;
  height: 30px;
  text-align: center;
  border: 1px solid var(--accent);
  background: var(--accent);
  margin-right: 50px;
  cursor: pointer;
  color: #fff;
  line-height: 30px;
}
.el-input {
  width: 300px;
}
</style>
